import { UserEntityInput } from "../../../services/users/user.types";
import { Role } from "../../../types";

export const initialValuesUser: UserEntityInput = {
  email: "",
  password: "",
  first_name: "",
  last_name: "",
  role: Role.STUDENT,
  school_id: null,
};

export const resolveRoleType = (value: string) => {
  switch (value) {
    case "ADMIN":
      return "Administrador";
    case "STUDENT":
      return "Estudiante";
    case "TEACHER":
      return "Profesor";
    case "COORDINATOR":
      return "Coordinador";
    default:
      return "Estudiante";
  }
};
